exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-production[data-v-ead84a16] {\n  background-color: #343a40;\n}\n.dashboard-production .dashboard-row[data-v-ead84a16] {\n  background-color: #343a40;\n  border-bottom: 4px solid #000;\n  min-height: 110px;\n}\n.dashboard-production .sidebars[data-v-ead84a16] {\n  width: 70px;\n  position: relative;\n  line-height: 1;\n}\n.dashboard-production .sidebars .rotate[data-v-ead84a16] {\n  font-size: 1.125rem;\n  line-height: 1;\n}\n.dashboard-production .line-height-1[data-v-ead84a16] {\n  line-height: 1;\n}\n.dashboard-production .huge-number[data-v-ead84a16] {\n  font-size: 2.75rem;\n}", ""]);

// exports
